export enum Breakpoint {
    Desktop = 767,
    Hd = 1919,
    Uhd = 3839
}
